// --- Team definitions (mockup-style groupings) ---

export interface TeamDefinition {
  id: string;
  name: string;
  icon: string; // lucide icon name
  roles: string[];
}

export const TEAM_DEFINITIONS: TeamDefinition[] = [
  {
    id: 'worship',
    name: 'Worship Team',
    icon: 'Music',
    roles: ['Worship Leader', 'Lead Vocals', 'Background Vocals', 'Harmony', 'Acoustic Guitar', 'Electric Guitar', 'Bass', 'Drums', 'Keys', 'Piano', 'Aux', 'Choir'],
  },
  {
    id: 'production',
    name: 'Production',
    icon: 'Video',
    roles: ['Sound Engineer', 'Lighting', 'Video', 'Projection', 'Live Stream', 'ProPresenter', 'Camera Operator', 'Stage Manager'],
  },
  {
    id: 'guest-services',
    name: 'Guest Services',
    icon: 'Users',
    roles: ['Greeter', 'Usher', 'Welcome Center', 'Parking', 'Security', 'Coffee Team'],
  },
];

export const formatTime12 = (date: Date | string): string => {
  const d = typeof date === 'string' ? new Date(date) : date;
  const h = d.getHours();
  const m = d.getMinutes();
  const period = h >= 12 ? 'PM' : 'AM';
  const h12 = h % 12 || 12;
  return `${h12}:${m.toString().padStart(2, '0')} ${period}`;
};
